module.exports = __webpack_public_path__ + "images/patterns/pattern_bg_category_icons_65b1ce71ff5aa977734ef34244f40dbe.jpg";